import { MESApiService } from "@dexteel/mesf-core";
import { get } from "lodash-es";
import type { Stand } from "../models/Stand";

export const getActiveStands = async ({
	signal,
}: {
	signal?: AbortSignal;
} = {}): Promise<Stand[]> => {
	const apiService = new MESApiService();
	const resp = await apiService.callV2(
		"[MILL].[GetStands]",
		[{ name: "OnlyActives", value: true }],
		signal,
	);
	if (resp.ok) return get(resp, "data.tables[0].rows", []) as Stand[];
	throw new Error(resp.message || "Error fetching stands");
};
